import React from 'react';
import {Text, Dialog, DialogHeader, DialogBody} from '@gravity-ui/uikit';
import styles from './ErrorModal.module.scss';

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  open,
  onClose,
  title = 'Ошибка соединения',
  message = 'Попробуйте еще раз позднее',
}) => {
  return (
    <Dialog open={open} onClose={onClose} className={styles.modal}>
      <DialogHeader />
      <DialogBody>
        <div className={styles.container}>
          <img src="/images/error-icon.svg" alt="Ошибка" className={styles.errorIcon} />
          <div className={styles.textContainer}>
            <Text variant="subheader-1" className={styles.title}>
              {title}
            </Text>
            <Text variant="body-1" className={styles.message}>
              {message}
            </Text>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
};
